import React, { useState, useEffect } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { loaderStateTrue, loaderStateFalse, setLocalTimezone } from '../src/Actions/AllAction';
import LoadingOverlay from 'react-loading-overlay';
import { FadeLoader, PulseLoader, ScaleLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import Popup from 'react-popup';
import V1Routes from '../src/V1/Routes/index';
import V2Routes from '../src/V2/Routes/index';
import V3Routes from '../src/V3/Routes/index';
import V3_1Routes from '../src/V3.0.1/Routes/index';
import V4Routes from '../src/V4/Routes/index';
import V5Routes from '../src/V5/Routes/index';
import V6Routes from '../src/V6/Routes/index';
import moment from 'moment-timezone';
import LoginRoute from './GlobalModules/Login/Routes/LoginRoute'
import MfaRoutes from './GlobalModules/Routes/MfaRoutes';
import ErrorBoundary from './Utility/Components/ErrorBoundary';
import ModalGlobal from './GlobalModules/Utility/Components/ModalGlobal';
import SmsVerification from './GlobalModules/Login/Components/SmsVerification';
import { getCurrentUser, verifySoftwareToken, mfaAssign } from './GlobalModules/Login/Controller/LoginController';
import EventEmitter from './GlobalModules/Utility/Components/EventEmitter';
import { setToken, setUserCredentials, logOutApp } from './GlobalModules/Login/Actions/LoginAction';
import GlobalRoutes from './GlobalModules/Routes/GlobalRoute';
import LoginIndex from './GlobalModules/Login/Routes/LoginIndex';
import './Utility/Public/css/responsiveDoc.scss';
import './toast-fix.css';
import * as Store from './storeRedux';
import { initializeNotifications, setupForegroundNotificationListener, initializeAudioOnInteraction } from './GlobalModules/Utility/Firebase';
import { Toaster } from '@mt/vite_react_shadcn_ts';

LoadingOverlay.propTypes = undefined;
const channel = new BroadcastChannel('foobar');

const App = (props) => {
    const { loaderStateFalse, token } = props;
    const [mfaModalFlag, setMfaModalFlag] = useState(false);
    const [live, setLive] = useState(0);

    // State for notifications
    const [notification, setNotification] = useState(null);
    useEffect(() => {
        async function fetchData() {
            try {
                setLive(1);
            } catch (error) {
            }
        }
        fetchData();
    }, []);

    // useEffect(() => {
    //     if (live === 1) {
    //         channelMessage();
    //     }
    // }, [live]);
    useEffect(() => {
        if (live === 1) {
            // If so, call the channelMessage function to set up the message listener
            channelMessage();
        }

        // Initialize Firebase notifications when user is logged in
        if (token && token !== "" && Object.keys(props.userCredentials).length > 0 && props.userCredentials.user_details && Object.keys(props.userCredentials.user_details).length > 0) {
            // console.log('token', token)
            initializeNotifications();
            const unsubscribe = setupForegroundNotificationListener(setNotification);

            // Set up event listeners to initialize audio on user interaction
            const initAudio = () => {
                // Try to initialize audio (function returns boolean, not a promise)
                const success = initializeAudioOnInteraction();
                if (success) {
                    // If successful, we can remove the event listeners
                    document.removeEventListener('click', initAudio);
                    document.removeEventListener('touchstart', initAudio);
                }
            };

            // Add event listeners for user interaction
            document.addEventListener('click', initAudio);
            document.addEventListener('touchstart', initAudio);

            // Clean up listener when component unmounts
            return () => {
                if (unsubscribe && typeof unsubscribe === 'function') {
                    unsubscribe();
                }
                // Remove event listeners
                document.removeEventListener('click', initAudio);
                document.removeEventListener('touchstart', initAudio);
            };
        }
    }, [live, token, props.userCredentials]);

    const channelMessage = () => {
        channel.onmessage = (event) => {
            if (event.data.isLogout) {
                const { setToken, setUserCredentials } = props;
                localStorage.setItem("selectedTabName", "")
                setToken("", "", "", "", [], [], '').then((res) => {
                    setUserCredentials({});
                })
                EventEmitter.emit("disconnected");
                // window.location.href = window.location.origin + "/";
            }
        };
        props.loaderStateFalse();
    }
    useEffect(() => {
        props.loaderStateFalse();
        checkExpiryOfToken();
    }, []);

    const checkExpiryOfToken = () => {
        const currentDateTime = new Date();
        const state = Store.default.getState()?.LoginReducer?.expiresIn;

        if (!state) {
            console.error("Token information is missing from the store.");
            return;
        }

        const expiryTime = new Date(state.expiryTime);
        const loggedInTime = new Date(state.loggedInTime);
        const expiryInterval = state.expiryInterval;

        if (isNaN(expiryTime.getTime()) || isNaN(loggedInTime.getTime())) {
            console.error("Invalid expiryTime or loggedInTime.");
            return;
        }

        const deltaDifference = (currentDateTime - loggedInTime) / 1000; // Convert to seconds

        if (currentDateTime >= expiryTime) {
            if (deltaDifference <= expiryInterval) {
                // Call your refresh token function here
                console.log("Token is expired but within the refresh interval. Refreshing token...");
                // refreshToken();
            } else {
                console.log("Token is expired and beyond the refresh interval. Logging out...");
                // Call your logout function
                const { setToken, setUserCredentials } = props;
                localStorage.setItem("selectedTabName", "")
                setToken("", "", "", "", [], [], '').then((res) => {
                    setUserCredentials({});
                })
                EventEmitter.emit("disconnected");
            }
        } else {
            console.log("Token is still valid.");
        }
    };


    const renderRoutes = () => {
        switch (userCredentials?.user_details?.version) {
            case 'v5':
                return <V5Routes />;
            case 'v4':
                return <V4Routes />;
            case 'v3.0.1':
                return <V3_1Routes />;
            case 'v3':
                return <V3Routes />;
            case 'v1':
                return <V1Routes />;
            case 'v2':
                return <V2Routes />;
            default:
                return <LoginRoute />;
        }
    };

    //after fetch user details check user is mandatory mfa or not
    useEffect(() => {
        if (Object.keys(props.userCredentials).length > 0 && props.userCredentials.user_details && Object.keys(props.userCredentials.user_details).length > 0 && props.userCredentials.user_details.hasOwnProperty('mfa') && props.userCredentials.user_details.mfa == null && props.userCredentials.user_details.user_type !== 'app_admin') {
            if (props.userGroup && props.userGroup.length > 0) {
                //check from all organisation , mfa is mandatory or not
                let userMfaEnableFlag = props.userGroup && props.userGroup.length > 0 && props.userGroup.some(user => user.is_mfa_required === true);
                if (userMfaEnableFlag) {
                    setMfaModalFlag(true)
                } else {
                    setMfaModalFlag(false)
                }
            }
        } else {

        }
    }, [props.userCredentials])

    //close mfa modal fn
    const closeMfaModalFn = () => {
        setMfaModalFlag(false)
    }

    //mfa otp submit fn callback
    const handleSubmitOtpVerfication = (otp, type) => {
        const { loaderStateTrue, loaderStateFalse } = props;
        if (type === 'authenticator') {
            loaderStateTrue();
            let data = {
                "mfaCode": otp.join(''),
            }
            verifySoftwareToken(data).then((response) => {
                if (response.success) {
                    const mfaAssignData = {
                        "mfa_type": "authenticator_app",
                        "user_name": props.userCredentials?.user_details?.user_email
                    }
                    mfaAssign(mfaAssignData).then((response) => {
                        if (response.success) {
                            setMfaModalFlag(false);
                            getCurrentUserFn();
                        } else {
                            Utility.toastNotifications(response.message, 'Error', 'error');
                        }
                        loaderStateFalse();
                    }).catch((error) => {
                        loaderStateFalse();
                    });
                } else {
                    Utility.toastNotifications(response.message, "Error", "error")
                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                    Utility.toastNotifications(error?.response?.message, "Warning", "warning")
                }
                loaderStateFalse();
            });
        }
    }

    //fetch current user data
    const getCurrentUserFn = () => {
        const { loaderStateTrue, loaderStateFalse, setUserCredentials, loginCredentials } = props;
        getCurrentUser().then((response) => {
            if (response.success) {
                setUserCredentials(response.data);
                //for routing , emit the data to mfa page 
                EventEmitter.emit("sendMessage", "route_permission")
            }
        }).catch((error) => {
            console.error("************error*************", error)
            loaderStateFalse();
        });
    }

    const { isLoading, userCredentials } = props;
    return (
        <LoadingOverlay
            active={isLoading}
            className='lodingOverlayDiv'
            spinner={<ScaleLoader 
                barCount={5}
                color={'#ffffff !important'}
                height={35}
                radius={2}
                speedMultiplier={0.2}
                width={4}
            />}
            styles={{
                overlay: (base) => ({
                    ...base,
                    background: 'rgba(255, 255, 255, 0.1)',
                    zIndex: '9999999999999'
                })
            }}
        >

            <Popup />
            {/* <ToastContainer /> */}
            <Toaster 
                position="bottom-right" 
                richColors 
                toastOptions={{
                    style: {
                        zIndex: 99999999
                    }
                }}
            />
            <Router>
                {/* {renderRoutes()} */}
                {Object.keys(props.userCredentials).length > 0 && token !== "" && (!props.userCredentials?.user_details?.version || props.userCredentials?.user_details?.version === '') ? (
                    <GlobalRoutes />
                ) : (
                    <>
                        {['v6', 'v5', 'v4', 'v3.0.1', 'v1', 'v2', 'v3'].includes(props.userCredentials?.user_details?.version) && token !== "" && props.mfa == null && props.userGroup && props.userGroup.length > 0 && props.userGroup.some(user => user.is_mfa_required === true) ? (
                            <MfaRoutes />
                        ) :
                            props.userCredentials?.user_details?.version === 'v1' && token !== "" ? (
                                <V1Routes />
                            ) : props.userCredentials?.user_details?.version === 'v2' && token !== "" ? (
                                <V2Routes />
                            ) : props.userCredentials?.user_details?.version === 'v3' && token !== "" ? (
                                <V3Routes />
                            ) : props.userCredentials?.user_details?.version === 'v3.0.1' && token !== "" ? (
                                <V3_1Routes />
                            ) : props.userCredentials?.user_details?.version === 'v4' && token !== "" ? (
                                <V4Routes />
                            ) : props.userCredentials?.user_details?.version === 'v5' && token !== "" ? (
                                <V5Routes />
                            ) : props.userCredentials?.user_details?.version === 'v6' && token !== "" ? (
                                <V6Routes />
                            ) : (
                                <LoginIndex />
                            )
                        }

                    </>
                )}
                {/* mfa modal */}
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={mfaModalFlag}
                        onHide={closeMfaModalFn}
                        title=""
                        className="modalcustomize mondimension smsVerificationModalContent userprofileSmsVerificationModal"
                        footer={false}
                        headerShow={false}
                        closeButton={true}
                        saveButtonLabel="Confirm"
                        saveButtonClassName="btn btn-primary savebtn"
                        cancelShow={true}
                        body={
                            <>
                                <ErrorBoundary title="GlobalAddEditModalContent Error">
                                    <SmsVerification
                                        formData={{ 'email': props.userCredentials?.user_details?.user_email }}
                                        callFrom={''}
                                        handleSubmitOtpVerfication={handleSubmitOtpVerfication}
                                        enableMfa={false}
                                        closeMfaModalFn={closeMfaModalFn}
                                        disableAction={true}
                                        landingPage={true}
                                    />
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>
            </Router>
        </LoadingOverlay>
    );
}

const mapStateToProps = (globalState) => {
    return {
        isLoading: globalState.mainReducerData.loaderState,
        userCredentials: globalState.LoginReducer.userCredentials,
        userGroup: globalState.LoginReducer?.userGroup,
        mfa: globalState?.LoginReducer?.userCredentials?.user_details?.mfa,
        token: globalState.LoginReducer.token,

    };
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials, setToken })(App);

